import { defineSlotRecipe } from '@chakra-ui/react';
import { fieldAnatomy } from '@chakra-ui/react/anatomy';

import { textFieldLabelGap } from './text-field.kds';

/** KDS Text Field field slots — Figma node 49:146. Registered as Chakra `field` in `theme/system.ts`. */
export const fieldSlotRecipe = defineSlotRecipe({
  slots: fieldAnatomy.keys(),
  base: {
    root: {
      gap: textFieldLabelGap,
      width: 'full',
    },
    label: {
      textStyle: 'default.medium',
      color: 'neutral.500',
      _disabled: {
        color: 'neutral.350',
        opacity: 0.8,
      },
    },
    requiredIndicator: {
      color: 'red.700',
    },
    errorText: {
      textStyle: 'small.regular',
      color: 'red.700',
    },
  },
});
